export const SKELETON_ROUTES = [
  '/home-tab',
  '/message-tab',
  '/profile-tab',
  '/contacts',
  '/chat-detail',
  '/report-request/referred-request',
  '/report-request/view-request',
  '/report-request/search-all-requests',
  '/RequestPayReport/list',
  '/create-request/categories',
  '/create-request/groups',
  '/create-request/subgroups',
  '/create-request/brands',
]

export const skeletonSilentRequest = { show_pros: false }

export function isSkeletonRoute (path) {
  if (!path) {
    return false
  }
  return SKELETON_ROUTES.some((route) => path === route || path.startsWith(route + '/'))
}

export function shouldShowGlobalSpinner (config, currentPath) {
  if (config.show_pros === false) {
    return false
  }
  if (config.show_pros === true) {
    return true
  }
  return !isSkeletonRoute(currentPath)
}
